import { Button, Input, Popover, Select, Space, Tag } from 'antd'
import React from 'react'
import TableAPI from '../../components/TableAPI'
import { Text } from '../../../styles/reactnative'
import EntryTime from '../../components/PositionColumns/EntryTime'
import UserTag from '../../components/UserTag'
import { TicketReply } from './TicketReply'
import { TagWrap } from '../../components/AdminUserModal/UserInfoTabs/styles'
import { COLORS } from '../../constants'
import { useUserList } from '../../hooks/user/userlist'
import { useUserGroup } from '../../hooks/user/usergroups'
import { CloseOutlined, FileSearchOutlined } from '@ant-design/icons'
export const TicketTable = ({ title, type }) => {
	const [userId, setUserId] = React.useState('')
	const [group, setGroup] = React.useState('*')

	const { type1 } = useUserGroup()
	const { usertype1 } = useUserList()

	return (
		<Space direction="vertical" style={{ width: '100%' }}>
			<Space.Compact direction="horizontal">
				<Select
					defaultValue={'*'}
					onChange={e => {
						setGroup(e)
					}}
					value={group}
					style={{ width: '100%', minWidth: 150 }}
					options={[
						{ value: '*', label: '그룹전체' },
						...(type1 || []),
					]}
				/>
				<Popover
					trigger={'click'}
					content={
						<Space style={{ alignItems: 'center' }}>
							<Select
								defaultValue={''}
								style={{ width: '100%', minWidth: 200 }}
								onChange={e => {
									setUserId(e)
								}}
								options={[
									{ value: '', label: '전체' },
									...(usertype1 || []),
								]}
							/>
						</Space>
					}>
					<Input
						placeholder="회원코드"
						style={{ width: '100%', minWidth: 180 }}
						value={userId}
						onChange={e => {
							setUserId(e.target.value)
						}}
					/>
				</Popover>
				<Button
					onClick={() => {
						setUserId('')
					}}
					style={{ paddingTop: 0 }}
					size="small">
					{userId ? <CloseOutlined /> : <FileSearchOutlined />}
				</Button>
			</Space.Compact>

			<TableAPI
				title={title}
				type={type}
				usermodal={true}
				autorefresh={false}
				loadingshow={false}
				height={'default'}
				apikey={`/ticket/list?group=${group}&${
					userId ? `userid=${userId}&` : ''
				}${
					(type && type != '*') || type === 0
						? `process=${type}&`
						: ''
				}t=`}
				columns={(mutate, showModal) => [
					{
						title: '번호',
						dataIndex: 'id',
						align: 'center',
						width: 100,
						render: (text, data) => <Text>{text}</Text>,
					},
					{
						title: '그룹명',
						dataIndex: 'group_name',
						align: 'center',
						width: 100,
					},
					{
						title: '회원',
						dataIndex: 'user_id',
						align: 'center',
						width: 150,
						render: (text, data) => (
							<UserTag
								userid={data?.user_id}
								email={data?.email}
								nickname={data?.fullname || data?.nickname}
								phone={data?.phone}
								onClick={() => {
									showModal(data?.user_id)
								}}
							/>
						),
					},
					{
						title: '생성일',
						dataIndex: 'created_at',
						align: 'center',
						width: 130,
						render: (text, data) => <EntryTime time={text} />,
					},
					{
						title: '진행',
						dataIndex: 'process',
						align: 'center',
						width: 100,
						render: (text, data) => (
							<TagWrap>
								{text == 0 ? (
									<Tag
										style={{
											backgroundColor: '#f79336',
											color: 'white',
										}}>
										대기
									</Tag>
								) : text == 2 ? (
									<Tag
										style={{
											backgroundColor: COLORS.lightGreen,
											color: 'white',
										}}>
										완료
									</Tag>
								) : text == 1 ? (
									<Tag
										style={{
											backgroundColor: '#444',
											color: 'white',
										}}>
										검토중
									</Tag>
								) : text == 4 ? (
									<Tag style={{ color: 'red' }}>거절됨</Tag>
								) : (
									<Tag>취소</Tag>
								)}
							</TagWrap>
						),
					},
					{
						title: '내용',
						dataIndex: 'content',
						align: 'left',
						render: (text, data) => (
							<Text style={{ justifyContent: 'flex-start' }}>
								{text}
							</Text>
						),
					},
					{
						title: '처리',
						dataIndex: 'reply',
						align: 'center',
						width: 500,
						render: (text, data) => (
							<TicketReply data={data} mutate={mutate} />
						),
					},
				]}
			/>
		</Space>
	)
}
